module.exports = __webpack_public_path__ + "static/media/token.ca3e6207.png";